
  document.addEventListener('DOMContentLoaded', function () {
    const triggerButton = document.querySelector('[data-size-guide-trigger]');
    const popup = document.querySelector('[data-size-guide-popup]');
    const closeButtons = document.querySelectorAll('[data-size-guide-close]');

    function openPopup() {
      if (popup) {
        popup.style.display = 'block';
        document.body.classList.add('popup-open'); 
      }
    }

    function closePopup() {
      if (popup) {
        popup.style.display = 'none';
        document.body.classList.remove('popup-open'); 
      }
    }

    if (triggerButton) {
      triggerButton.addEventListener('click', function (event) {
        event.stopPropagation(); 
        openPopup();
      });
    }

    closeButtons.forEach(button => {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        closePopup();
      });
    });

    document.addEventListener('click', function (event) {
      if (popup && popup.style.display === 'block') {
        const isClickInside = popup.contains(event.target) || (triggerButton && triggerButton.contains(event.target));
        if (!isClickInside) {
          closePopup();
        }
      }
    });

    if (popup) {
      popup.querySelector('.size-guide-popup__content')?.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }
  });

